import React, { useEffect } from "react";
import { base_url } from "Backend/api";
import { isOrderDelivered, shouldShowRatePopup } from "utils/orderReviewStorage";
import { useOrderReviewModal } from "contexts/OrderReviewModalContext";

/**
 * After login / first load: opens the rate modal once for the newest
 * delivered order that was neither rated nor dismissed (same rules as Flutter).
 */
export default function PendingRateOrderGate() {
  const { openOrderReview } = useOrderReviewModal();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return undefined;

    let cancelled = false;

    (async () => {
      try {
        const res = await fetch(`${base_url}/api/orders`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const result = await res.json();
        if (!result.status || !Array.isArray(result.data?.orders)) return;

        const delivered = result.data.orders.filter((o) => isOrderDelivered(o.status))
          .sort(
            (a, b) =>
              new Date(b.created_at || 0) - new Date(a.created_at || 0)
          );

        const next = delivered.find(
          (o) => o.slug && shouldShowRatePopup(o.slug, o.is_rated)
        );
        if (!cancelled && next?.slug) {
          openOrderReview(next.slug);
        }
      } catch (e) {
        console.error(e);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [openOrderReview]);

  return null;
}
